export default {
  alias   : 'regulations_tipos_sigla',
  route   : '/app/normatividad/regulations_tipos_sigla',
  hash    : false,
  store   : false,
  name    : 'tip_description',
  key     : 'id',
  /*relations : [
      {
          attribute : 'unidades',
          alias     : 'unidades',
          module    : 'unit'
      }
    ],*/
  default : {
    id                  : null,
    regulations_tipo_id : null,
    sig_codigo          : null,
    sig_name            : false,
    sig_siglas          : false,
    sig_manual          : false,
    created_at          : null,
    updated_at          : null,
  }
}
